package com.essntl.features.itinerary.ui.all_itinerary.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.itinerary.ui.all_itinerary.AllItineraryEvent
import com.essntl.features.itinerary.ui.all_itinerary.AllItineraryState
import com.essntl.uikit.components.button.outline.EsMediumOutlineButton
import com.essntl.uikit.components.datepicker.EsDateRangePickerDialog
import com.essntl.uikit.components.iconbutton.outline.EsMediumOutlineIconButton
import com.essntl.uikit.components.iconbutton.primary.EsMediumPrimaryIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.EsRowDefaultItem
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ItinerariesHeader(
    state: AllItineraryState,
    onEvent: (AllItineraryEvent) -> Unit,
    modifier: Modifier = Modifier,
) {
    var isDateRangePickerVisible by remember { mutableStateOf(false) }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier =
        modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        Text(
            text = "Itineraries",
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.h2Bold32,
        )

        EsInput(
            value = state.filterOptions.searchText,
            onValueChange = {
                onEvent(
                    AllItineraryEvent.FilterItinerary(
                        filterOptions = state.filterOptions.copy(
                            searchText = it,
                        ),
                    ),
                )
            },
            prefix = {
                EsLargeIcon(
                    res = EsIcons.Search,
                )
            },
            placeholder = "Search",
            shape = RoundedCornerShape(50.dp),
            modifier =
            Modifier
                .width(268.dp),
        )

        Row(
            verticalAlignment = Alignment.CenterVertically,
        ) {
            if (state.filterOptions.selectedFromDate.isNotEmpty() ||
                state.filterOptions.selectedToDate.isNotEmpty()
            ) {
                EsMediumPrimaryIconButton(
                    iconRes = EsIcons.Calendar,
                    onClick = {
                        isDateRangePickerVisible = !isDateRangePickerVisible
                    },
                )
            } else {
                EsMediumOutlineIconButton(
                    iconRes = EsIcons.Calendar,
                    onClick = {
                        isDateRangePickerVisible = !isDateRangePickerVisible
                    },
                )
            }

            Spacer(modifier = Modifier.width(1.spacing))

            EsMediumOutlineButton(
                onClick = {
                    onEvent(
                        AllItineraryEvent.FilterItinerary(
                            state.filterOptions.copy(
                                completed = !state.filterOptions.completed,
                            ),
                        ),
                    )
                },
                suffixIconRes = if (state.filterOptions.completed) EsIcons.Tick else null,
                text = "Show completed",
            )

            Spacer(modifier = Modifier.width(1.spacing))

            ItineraryFilterSection(
                filterOptions = state.filterOptions,
                onFilterOptionsChange = {
                    onEvent(
                        AllItineraryEvent.FilterItinerary(filterOptions = it),
                    )
                },
            )
        }
    }

    Spacer(modifier = Modifier.height(1.spacing))

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier =
        Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.ListRowVerticalPadding,
                horizontal = EsConstants.ListRowHorizontalPadding + EsConstants.SectionHorizontalPadding,
            )
            .height(EsConstants.ListColumnHeaderHeight),
    ) {
        // Itinerary information
        EsRowDefaultItem(
            text = "Itinerary information",
            isFirst = true,
            weight = 2f,
        )

        // Owner
        EsRowDefaultItem(
            text = "Owner",
        )

        // Destination
        EsRowDefaultItem(
            text = "Area",
        )

        // Date
        EsRowDefaultItem(
            text = "Date",
        )

        // Client
        EsRowDefaultItem(
            text = "Traveller",
        )

        // Date confirmed
        EsRowDefaultItem(
            text = "Date confirmed",
        )

        // Last changed
        EsRowDefaultItem(
            text = "Last changed",
        )

        // Last changed
        EsRowDefaultItem(
            text = "Actions",
        )
    }

    EsDateRangePickerDialog(
        isExpanded = isDateRangePickerVisible,
        onDismissRequest = { isDateRangePickerVisible = false },
        fromDate = state.filterOptions.selectedFromDate,
        toDate = state.filterOptions.selectedToDate,
        onDateRangeChange = { from, to ->
            onEvent(
                AllItineraryEvent.FilterItinerary(
                    state.filterOptions.copy(
                        selectedFromDate = from,
                        selectedToDate = to,
                    ),
                ),
            )
        },
    )
}
